<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="appContents"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options="options"
      :page="page"
      :items-per-page="itemsPerPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :multi-sort="multiSort"
      v-on="listeners"
    >
      <template v-slot:item.type_id="{ item }">{{ item.type }}</template>
      <template v-slot:item.category_id="{ item }">{{
        item.category
      }}</template>

      <template v-slot:item.action="{ item }">
        <action-slot-component
          :item="item"
          :route-name="contentRoutes[item.type_id]"
          :route-params="{ id: item.id }"
          :text="$t('ITEM.EDIT')"
          icon="mdi-pencil"
          @show="$emit('edit', item)"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { isEqual } from 'lodash';
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';
import typeContentRoutes from '@/modules/app_content/common/content-types-routes';

export default {
  name: 'AppContentList',
  components: { ActionSlotComponent },

  props: {
    appContents: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      default: () => ({
        total: -1
      })
    },
    options: {
      type: Object,
      default: () => {}
    },
    page: {
      type: Number,
      default: 1
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    sortBy: {
      type: [String, Array],
      default: 'id'
    },
    sortDesc: {
      type: [Boolean, Array],
      default: false
    },
    multiSort: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    contentRoutes: typeContentRoutes,
    footerProps: {
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 50, 100]
    }
  }),

  computed: {
    listeners: function() {
      return Object.assign({}, this.$listeners, {
        'update:options': this.refreshData
      });
    },

    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.TITLE'),
          value: 'title'
        },
        {
          text: this.$t('APP_CONTENT.NAME_IN_THE_APP'),
          value: 'name'
        },
        {
          text: this.$t('ITEM.CATEGORY'),
          value: 'category.name'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type.name'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  },

  methods: {
    refreshData(options) {
      if (isEqual(options, this.options)) {
        return;
      }

      this.$emit('update:options', options);
    },
    edit(item) {
      this.$emit('edit', item);
    }
  }
};
</script>
